import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { S3_BUCKET_URL } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import { FIRST_IMPRESSION_OPTIONS } from './constants';
import { PageStyles, TitleStyles } from './FirstImpressionScreen.styles';

export const FirstImpressionScreen: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'FirstImpression',
      });
    }
  }, []);

  const { wizard } = useOnboarding();
  const form = useFormContext<LayoutDataType>();
  const firstImpression = form.watch('first_impression');

  const handleChange = (
    option: OnbOptionType<LayoutDataType['first_impression']>,
  ) => {
    userService.createOrUpdate({
      onboarding_data: {
        first_impression: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <PageStyles
      bgImage={
        <img
          src={`${S3_BUCKET_URL}/layout-own-ai-pool/first-impression/background.jpg`}
          alt="AI Character"
        />
      }
      background="dark-solid"
    >
      <IonContent>
        <TitleStyles>
          She steps in with confidence.
          <br />
          What catches your eye first?
        </TitleStyles>
        <OnboardingOptionsList>
          {FIRST_IMPRESSION_OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={firstImpression === option.id}
              control={form.control}
              option={option}
              name="first_impression"
              key={option.id}
              onChange={() => handleChange(option)}
              TEST_ID={`first-impression-${option.id}`}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>
    </PageStyles>
  );
};
